<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="notesModal" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="notesModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader"> {{ domainName }} </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div v-if="loading" class="loader"></div>
          <div v-else class="modal-body">
            <div v-if="migration.status !== 'finished'" class="row">
              <div class="col-md-12">
                <form @submit.prevent="addNewNote">
                  <label>Note:</label>
                  <div class="row mt-2">
                    <div class="col-md-12">
                      <textarea class="form-control" required rows="3" v-model="newNote"></textarea>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-12">
                      <label>Attachment:</label>
                      <input type="file" class="form-control" id="customFile" ref="file" @change="changeFile($event)">
                    </div>
                  </div>
                  <button class="btn btn-sm btn-primary float-right" type="submit">Submit</button>
                </form>
              </div>
            </div>
            <section v-if="migration.notes && migration.notes.length > 0">
              <hr v-if="migration.status !== 'finished'">
              <h5>Added Notes</h5>
              <table class="table table-hover">
                <thead>
                  <th>Note</th>
                  <th>Attachment</th>
                  <th>Added By</th>
                  <th v-if="migration.status !== 'finished'">Action</th>
                </thead>
                <tbody>
                    <tr v-for="(row, index) of migration.notes" :key="index">
                      <td>
                        <span v-html="row.text"></span>
                      </td>
                      <td>
                        <a v-if="row.imageUrl" :href="row.imageUrl" target="_blank">Attachment</a>
                      </td>
                      <td>
                        {{row.addedBy}}
                      </td>
                      <td  v-if="migration.status !== 'finished'">
<!--                        <button class="btn btn-sm btn-primary my-1 mr-1" @click="editNote(index)"><i class="fa fa-pencil"></i></button>-->
                        <button class="btn btn-sm btn-danger my-1" @click="deleteNote(index)"><i class="fa fa-trash"></i></button>
                      </td>
                    </tr>
                </tbody>
              </table>
            </section>
            <section v-else-if="migration.status === 'finished'">
              <span>No notes available</span>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db, storage} from "@/firebase/init"
export default {
  name: "migrationNotesModal",
  data () {
    return {
      newNote: null,
      domainName: null,
      migration: {},
      editIndex: null,
      file: null,
      event: null,
      url: null,
      loading: false
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    load (migration) {
      this.migration = migration
      this.domainName = migration.siteDetails.domainName
      $('#notesModal').modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
    changeFile (event) {
      this.file = event.target.files[0]
      this.url = window.URL.createObjectURL(this.file)
      this.event = event
    },
    async addNewNote () {
      let downloadURL = null
      this.loading = true
      if (this.file) {
        if (this.file) {
          const storageRef = storage.ref();
          const timestamp = new Date().getTime().toString();
          const fileRef = storageRef.child('migration-notes/' + this.file.name + timestamp );
          const uploadTask =  await fileRef.put(this.file)
          downloadURL = await uploadTask.ref.getDownloadURL()
        }
      }
      if (this.editIndex === null) {
        if (!this.migration.notes) {
          this.migration.notes = []
        }
        try {
          await this.addNoteInTicket(this.newNote)
        } catch (e) {
          console.log('Error in adding note ticket')
        }
        this.newNote = this.newNote.replace(/\n/g, '<br>')
        const migObject = {
          text: this.newNote,
          addedBy: this.user.firstName + ' ' + this.user.lastName,
          imageUrl: downloadURL
        }
        this.migration.notes.push(migObject)
      } else {
        this.migration.notes[this.editIndex].text = this.newNote
      }
      await this.updateMigrtaionNotes()
      if (this.file) {
        if (this.event) {
          this.event.target.value = ''
        }
        this.file = null
        this.url = null
      }
      this.loading = false
    },
    async addNoteInTicket (note) {
      if(this.migration.ticketId){
        try {
          await this.$http.post('host-bill/update-ticket-note', {
            ticketId: this.migration.ticketId,
            notes: note,
            grant_type: 'token'
          });
        } catch (e) {
          console.log(e.toString())
          console.log('Error in adding note in ticket')
        }
      }
    },
    async updateMigrtaionNotes () {
      await db.collection('savedMigrations').doc(this.migration.docId).update({
        notes: this.migration.notes,
        modified: new Date().toISOString()
      })
      this.newNote = null
      this.editIndex = null
    },
    async deleteNote (index) {
      this.loading = true
      this.migration.notes.splice(index, 1)
      await this.updateMigrtaionNotes()
      this.loading = false
    },
    editNote (index) {
      this.newNote = this.migration.notes[index].text
      this.editIndex = index
    }
  }
}
</script>

<style scoped>

</style>
